import { render, staticRenderFns } from "./ChatConversation.vue?vue&type=template&id=5e0c7587&scoped=true&"
import script from "./ChatConversation.vue?vue&type=script&lang=js&"
export * from "./ChatConversation.vue?vue&type=script&lang=js&"
import style0 from "./ChatConversation.vue?vue&type=style&index=0&id=5e0c7587&prod&scoped=true&lang=css&"
import style1 from "./ChatConversation.vue?vue&type=style&index=1&id=5e0c7587&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0c7587",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VChip,VDialog,VFileInput,VIcon,VImg,VMenu,VTextField,VTextarea})
